import SearcherInput from './SearcherInput';

export default SearcherInput;